export enum AlertMethod {
  Mobile = 1,
  Email = 2,
  Both = 3
}
